'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var cropper = {exports: {}};

exports.cropper = cropper;
